import type { MaasNodeGroupFieldPaths } from '@/delivery-type-plugin/capabilities/maas-node-groups/nodeGroupFieldPaths';

/** 缓存节点表单路径（与推理拓扑隔离；initCommand 仅满足共享路径类型，拓扑级不再提交） */
export const KV_OFFLOAD_NODE_GROUP_FIELD_PATHS: MaasNodeGroupFieldPaths = {
  runMode: 'kvOffloadRunMode',
  masterNodes: 'kvOffloadMasterNodes',
  workerNodes: 'kvOffloadWorkerNodes',
  masterSystemDisk: 'kvOffload.master.systemDiskSize',
  workerSystemDisk: 'kvOffload.worker.systemDiskSize',
  masterSystemDiskPricing: 'kvOffloadMasterSystemDiskPricing',
  workerSystemDiskPricing: 'kvOffloadWorkerSystemDiskPricing',
  replicas: 'kvOffloadReplicas',
  taskTemplate: 'kvOffloadTaskTemplate',
  initCommand: 'kvOffloadInitCommand',
  commonEnv: 'kvOffloadCommonEnv',
};

/** 取消勾选缓存节点时清空的表单字段 */
export const KV_OFFLOAD_RESET_FIELD_PATHS = [
  'kvOffloadReplicas',
  'kvOffloadTaskTemplate',
  'kvOffloadRunMode',
  'kvOffloadMasterNodes',
  'kvOffloadWorkerNodes',
  'kvOffload.master.systemDiskSize',
  'kvOffload.worker.systemDiskSize',
  'kvOffloadMasterSystemDiskPricing',
  'kvOffloadWorkerSystemDiskPricing',
  'kvOffloadCommonEnv',
] as const;
